<template>

<Password></Password>

</template>


<script>

import Password from '../../components/Password.vue';

export default {


 components:{

     Password

  }

}


</script>